import React, { useState, useContext } from 'react'
import { EventListContext } from '../../../utils/context'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import { Checkbox, Select, Textarea } from '../../../components/ModalInputs'
import Table from '../../../components/Table'
import { IoIosAdd } from 'react-icons/io'
import { BiTrash } from 'react-icons/bi'
import ModalFooter from './Components/ModalFooter'

// Mock данные для селектов (TODO: заменить на реальные API)
const PARTICIPATION_FORMS = [
  { id: 1, name: 'Очная' },
  { id: 2, name: 'Заочная' },
  { id: 3, name: 'Дистанционная' },
  { id: 4, name: 'Смешанная' },
]

const SUBJECTS = [
  { id: 1, name: 'Математика' },
  { id: 2, name: 'Русский язык' },
  { id: 3, name: 'Физика' },
  { id: 4, name: 'История' },
  { id: 5, name: 'Информатика' },
]

const ACTIVITY_KINDS = [
  { id: 1, name: 'Открытый урок' },
  { id: 2, name: 'Мастер-класс' },
  { id: 3, name: 'Семинар' },
  { id: 4, name: 'Конференция' },
]

const RESULTS = [
  { id: 1, name: 'Победитель' },
  { id: 2, name: 'Призер' },
  { id: 3, name: 'Участник' },
  { id: 4, name: 'Лауреат' },
]

const AWARD_DOCUMENTS = [
  { id: 1, name: 'Грамота' },
  { id: 2, name: 'Диплом' },
  { id: 3, name: 'Благодарность' },
  { id: 4, name: 'Сертификат' },
]

const CERTIFICATES = [
  { id: 1, name: 'Сертификат участника' },
  { id: 2, name: 'Сертификат победителя' },
  { id: 3, name: 'Сертификат призера' },
]

const ACTIVITY_DIRECTIONS = [
  { id: 1, name: 'Учебная' },
  { id: 2, name: 'Воспитательная' },
  { id: 3, name: 'Научная' },
  { id: 4, name: 'Методическая' },
]

const PARAMETERS = [
  { name: "Инновационная деятельность сотрудников", id: 1 },
  { name: "Внеклассное мероприятие", id: 2 },
  { name: "Представление педагогического опыта", id: 3 },
  { name: "Выступления на конференциях, семинарах, проведение мастер-классов", id: 4 },
  { name: "Участие сотрудников в профессиональных конкурсах, олимпиадах", id: 5 },
  { name: "Общественная активность сотрудников", id: 6 },
  { name: "Участие обучающихся в предметных олимпиадах", id: 7 },
  { name: "Участие обучающихся в конкурсах, соревнованиях", id: 8 },
]

export default function Parameters() {
  const { closeModal, event, formik } = useContext(EventListContext)

  const { values, setFieldValue, handleSubmit } = formik

  const [selectedType, setSelectedType] = useState(1)
  const [students, setStudents] = useState([])

  const handleSelectType = (data) => {
    setSelectedType(selectedType === data.id ? null : data.id)
  }

  const handleAddStudent = () => {
    setStudents([...students, { id: Date.now(), fio: '', class: '' }])
  }

  const handleRemoveStudent = (id) => {
    setStudents(students.filter(s => s.id !== id))
  }

  const handleStudentChange = (id, field, value) => {
    setStudents(students.map(s =>
      s.id === id ? { ...s, [field]: value } : s
    ))
  }

  const renderOption = (option) => (
    <option key={option.id} value={option.id}>{option.name}</option>
  )

  // Параметры хранятся в main секции с префиксом resp_
  const mainValues = values.main || {}

  const getParamValue = (field) => {
    // Маппинг полей параметров на поля main
    const fieldMap = {
      'participation_form': 'resp_kind',
      'content': 'resp_content',
      'results': 'resp_result',
      'subject': 'resp_subject',
      'kind': 'resp_subtype',
      'lesson_topic': 'resp_desc1',
      'reviews': 'resp_desc2',
      'topic': 'resp_desc1',
      'has_certificate': 'resp_desc2',
      'result': 'resp_result',
      'award_document': 'resp_desc1',
      'direction': 'resp_subtype',
      'documents': 'resp_desc2',
      'certificate': 'resp_desc1',
      'work_name': 'resp_desc2'
    }
    const mappedField = fieldMap[field] || field
    return mainValues[mappedField] || ''
  }

  const setParamValue = (field, value) => {
    const fieldMap = {
      'participation_form': 'resp_kind',
      'content': 'resp_content',
      'results': 'resp_result',
      'subject': 'resp_subject',
      'kind': 'resp_subtype',
      'lesson_topic': 'resp_desc1',
      'reviews': 'resp_desc2',
      'topic': 'resp_desc1',
      'has_certificate': 'resp_desc2',
      'result': 'resp_result',
      'award_document': 'resp_desc1',
      'direction': 'resp_subtype',
      'documents': 'resp_desc2',
      'certificate': 'resp_desc1',
      'work_name': 'resp_desc2'
    }
    const mappedField = fieldMap[field] || field
    setFieldValue(`main.${mappedField}`, value)
  }

  const renderTab = () => {
    switch (selectedType) {
      case 1:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Форма участия'
                name={`1.participation_form`}
                value={getParamValue('participation_form')}
                onChange={(e) => setParamValue('participation_form', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {PARTICIPATION_FORMS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Содержание деятельности'
                value={getParamValue('content')}
                onChange={(e) => setParamValue('content', e.target.value)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Результаты деятельности'
                value={getParamValue('results')}
                onChange={(e) => setParamValue('results', e.target.value)}
              />
            </div>
          </>
        )

      case 2:
        return (
          <div className={styles.inputsRow}>
            <Select
              label='Предмет'
              name={`2.subject`}
              value={getParamValue('subject')}
              onChange={(e) => setParamValue('subject', e.target.value)}
              style={{ width: '400px', marginBottom: '10px' }}
            >
              <option value=''>Выбрать</option>
              {SUBJECTS.map(renderOption)}
            </Select>
          </div>
        )

      case 3:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Предмет'
                value={getParamValue('subject')}
                onChange={(e) => setParamValue('subject', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {SUBJECTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Вид'
                value={getParamValue('kind')}
                onChange={(e) => setParamValue('kind', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {ACTIVITY_KINDS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Тема урока'
                value={getParamValue('lesson_topic')}
                onChange={(e) => setParamValue('lesson_topic', e.target.value)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Отзывы об уроке'
                value={getParamValue('reviews')}
                onChange={(e) => setParamValue('reviews', e.target.value)}
              />
            </div>
          </>
        )

      case 4:
        return (
          <>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Тема'
                value={getParamValue('topic')}
                onChange={(e) => setParamValue('topic', e.target.value)}
              />
            </div>
            <Checkbox
              name='has_certificate'
              label='Сертификат участника'
              checked={getParamValue('has_certificate')}
              onChange={() => setParamValue('has_certificate', !getParamValue('has_certificate'))}
            />
          </>
        )

      case 5:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Предмет'
                value={getParamValue('subject')}
                onChange={(e) => setParamValue('subject', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {SUBJECTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Результат'
                value={getParamValue('result')}
                onChange={(e) => setParamValue('result', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {RESULTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Документ награждения'
                value={getParamValue('award_document')}
                onChange={(e) => setParamValue('award_document', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {AWARD_DOCUMENTS.map(renderOption)}
              </Select>
            </div>
          </>
        )

      case 6:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Предмет'
                value={getParamValue('subject')}
                onChange={(e) => setParamValue('subject', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {SUBJECTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Направление деятельности'
                value={getParamValue('direction')}
                onChange={(e) => setParamValue('direction', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {ACTIVITY_DIRECTIONS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Содержание деятельности'
                value={getParamValue('content')}
                onChange={(e) => setParamValue('content', e.target.value)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Подтверждающие документы'
                value={getParamValue('documents')}
                onChange={(e) => setParamValue('documents', e.target.value)}
              />
            </div>
          </>
        )

      case 7:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Предмет'
                value={getParamValue('subject')}
                onChange={(e) => setParamValue('subject', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {SUBJECTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Сертификат'
                value={getParamValue('certificate')}
                onChange={(e) => setParamValue('certificate', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {CERTIFICATES.map(renderOption)}
              </Select>
            </div>
          </>
        )

      case 8:
        return (
          <>
            <div className={styles.inputsRow}>
              <Select
                label='Предмет'
                value={getParamValue('subject')}
                onChange={(e) => setParamValue('subject', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {SUBJECTS.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Сертификат'
                value={getParamValue('certificate')}
                onChange={(e) => setParamValue('certificate', e.target.value)}
                style={{ width: '400px', marginBottom: '10px' }}
              >
                <option value=''>Выбрать</option>
                {CERTIFICATES.map(renderOption)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                style={{ resize: 'none', width: '750px', height: '100px' }}
                label='Название работы'
                value={getParamValue('work_name')}
                onChange={(e) => setParamValue('work_name', e.target.value)}
              />
            </div>
            <Table className={styles.tables}>
              <thead>
                <tr>
                  <th>Ученик</th>
                  <th>Класс</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {students.map(student => (
                  <tr key={student.id}>
                    <td>
                      <input
                        type="text"
                        value={student.fio}
                        onChange={(e) => handleStudentChange(student.id, 'fio', e.target.value)}
                        placeholder="ФИО ученика"
                        style={{ width: '200px' }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={student.class}
                        onChange={(e) => handleStudentChange(student.id, 'class', e.target.value)}
                        placeholder="Класс"
                        style={{ width: '100px' }}
                      />
                    </td>
                    <td>
                      <i className={styles.trash} onClick={() => handleRemoveStudent(student.id)}>
                        <BiTrash />
                      </i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Button
              style={{ padding: '.5rem 1.5rem', margin: '12px' }}
              onClick={handleAddStudent}
            >
              <IoIosAdd size={30} />
              Добавить
            </Button>
          </>
        )

      default:
        return null
    }
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div>
          {PARAMETERS.length !== 0 &&
            <Table className={styles.tables}>
              <thead>
                <tr>
                  <th>Тип параметра</th>
                </tr>
              </thead>
              <tbody>
                {PARAMETERS.map((data) => (
                  <tr
                    key={data.id}
                    onClick={() => handleSelectType(data)}
                    style={{ backgroundColor: selectedType === data.id ? '#3689FF' : '', cursor: 'pointer' }}
                  >
                    <td style={{ color: selectedType === data.id ? 'white' : '', textAlign: 'left' }}>
                      {data.name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          }
        </div>
        <br />
        <hr />
        <div className={styles.tabWrapper}>
          {renderTab()}
        </div>
      </div>

      <ModalFooter
        event={event}
        onSave={handleSubmit}
        onClose={closeModal}
        showCheckbox={false}
      />
    </>
  )
}
